import { motion } from "framer-motion";
import { PhoneCall, ClipboardCheck, UserRoundCheck } from "lucide-react";

const steps = [
  {
    icon: PhoneCall,
    step: "01",
    title: "Contact Us",
    description: "Reach out via phone, WhatsApp, or our online form. Tell us about your care needs.",
  },
  {
    icon: ClipboardCheck,
    step: "02",
    title: "Care Plan Assessment",
    description: "Our team evaluates requirements and creates a personalized care plan for your loved one.",
  },
  {
    icon: UserRoundCheck,
    step: "03",
    title: "Caregiver Assigned",
    description: "A verified, trained caregiver is matched and assigned — care starts at your doorstep.",
  },
];

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 md:py-28 bg-gradient-to-br from-[#F0FDFA] to-[#F0F9FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-semibold text-[#14B8A6] uppercase tracking-wider font-body">
            Simple Process
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#0F172A] tracking-tight mt-3">
            How It Works
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-[#64748B] mt-4 max-w-2xl mx-auto font-body">
            Getting started with CareCrony is easy. Three simple steps to quality home care.
          </p>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
          transition={{ staggerChildren: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {steps.map((s, index) => (
            <motion.div
              key={s.step}
              variants={item}
              data-testid={`step-${s.step}`}
              className="relative text-center"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-px border-t-2 border-dashed border-[#14B8A6]/20" />
              )}

              <div className="relative inline-flex items-center justify-center w-24 h-24 rounded-3xl bg-white shadow-[0_4px_20px_-2px_rgba(15,118,110,0.1)] border border-slate-100 mb-6">
                <s.icon className="w-8 h-8 text-[#14B8A6]" strokeWidth={1.5} />
                <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-[#14B8A6] text-white text-sm font-bold flex items-center justify-center font-heading">
                  {s.step}
                </span>
              </div>

              <h3 className="font-heading text-xl font-semibold text-[#0F172A] mb-3">
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed text-[#475569] font-body max-w-xs mx-auto">
                {s.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
